(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["@eriksdigital/raffaella"] = factory(require("react"));
	else
		root["@eriksdigital/raffaella"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__359__) => {
return 